import React, { memo } from 'react'
import { Path } from 'react-native-svg'

import { IconBase } from '../IconBase'
import { IconProps } from '../IconProps'
import { themed } from '../themed'

const Icon = (props) => {
  const { color = 'black', size = 24, ...otherProps } = props
  return (
    <IconBase
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...otherProps}
    >
      <Path
        d="M11.5 1.75H4.5C4.16848 1.75 3.85054 1.8817 3.61612 2.11612C3.3817 2.35054 3.25 2.66848 3.25 3V14C3.24996 14.1339 3.28576 14.2654 3.35369 14.3808C3.42162 14.4961 3.51921 14.5912 3.63631 14.6562C3.75342 14.7211 3.88577 14.7535 4.01962 14.75C4.15348 14.7465 4.28395 14.7072 4.3975 14.6362L7.99937 12.3862L11.6025 14.6362C11.716 14.7072 11.8465 14.7465 11.9804 14.75C12.1142 14.7535 12.2466 14.7211 12.3637 14.6562C12.4808 14.5912 12.5784 14.4961 12.6463 14.3808C12.7142 14.2654 12.75 14.1339 12.75 14V3C12.75 2.66848 12.6183 2.35054 12.3839 2.11612C12.1495 1.8817 11.8315 1.75 11.5 1.75Z"
        fill={`${color}`}
      />
    </IconBase>
  )
}

Icon.displayName = 'IconBookmarkFilled'

export const IconBookmarkFilled = memo(themed(Icon))
